// A code chunk that couldn't be loaded: usually a tab opened before a deploy
// asking for one the new build no longer serves. Webpack's ChunkLoadError,
// and Vite's failed dynamic imports in Chrome, Safari and Firefox.
const CHUNK_ERROR_MESSAGE =
  /loading chunk \d+ failed|failed to fetch dynamically imported module|importing a module script failed|error loading dynamically imported module/i;

const isChunkLoadError = (error: unknown): boolean =>
  error instanceof Error &&
  (error.name === 'ChunkLoadError' || CHUNK_ERROR_MESSAGE.test(error.message));

export default isChunkLoadError;
